import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { User, Lock, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/ui";

export default function Login() {
  const { login, user, checked } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (checked && user) nav("/dashboard", { replace: true });
  }, [checked, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(username, password);
    setBusy(false);
    if (res.ok) nav("/dashboard", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0B0F19] px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(99,102,241,0.10),transparent_45%),radial-gradient(circle_at_80%_70%,rgba(99,102,241,0.08),transparent_40%)]" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8 animate-slide-up">
          <h1 className="text-4xl font-extrabold font-display tracking-tight text-slate-900 dark:text-white">
            Sales<span className="text-indigo-600 dark:text-indigo-400">CRM</span>
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-2">Manage your sales pipeline efficiently</p>
        </div>
        <form onSubmit={submit} className="card p-8 animate-slide-up" data-testid="login-form">
          <h2 className="text-xl font-bold font-display text-slate-900 dark:text-white text-center">Welcome Back</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 text-center mt-1 mb-6">Sign in to your account to continue</p>

          {error && (
            <div className="mb-4 rounded-md border border-rose-200 dark:border-rose-800 bg-rose-50 dark:bg-rose-500/10 px-3 py-2 text-sm text-rose-700 dark:text-rose-400" data-testid="login-error">{error}</div>
          )}

          <label className="text-sm font-medium text-slate-600 dark:text-slate-300">Username</label>
          <div className="relative mt-1 mb-4">
            <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input className="input pl-9" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="username-input" autoFocus />
          </div>

          <label className="text-sm font-medium text-slate-600 dark:text-slate-300">Password</label>
          <div className="relative mt-1 mb-6">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input type="password" className="input pl-9" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="password-input" />
          </div>

          <button type="submit" className="btn-primary w-full" disabled={busy || !username || !password} data-testid="login-submit">
            {busy ? <Spinner className="w-4 h-4" /> : <>Sign In <ArrowRight className="w-4 h-4" /></>}
          </button>
          <p className="text-xs text-center text-slate-400 mt-6">By continuing, you agree to our Terms of Service and Privacy Policy.</p>
        </form>
      </div>
    </div>
  );
}
